import { Avatar, Grid2, IconButton, styled, Typography } from "@mui/material";
import EditLogoModal from "Pages/CompanyInformation/EditLogoModal";
import { useState } from "react";
import GKButton from "./GKButton";
import { DeleteIcon } from "./Icons";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const GKImageUploader = ({
  handleProfilePicDelete,
  selectedImage,
  setSelectedImage,
  croppedImage,
  setCroppedImage,
  form,
  logoName,
  buttonName,
  deleteLoading,
}: {
  handleProfilePicDelete: any;
  selectedImage: any;
  setSelectedImage: any;
  croppedImage: any;
  setCroppedImage: any;
  form: any;
  logoName: string;
  buttonName: string;
  deleteLoading?: boolean;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleProfilePicChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result as string);
        form.setValue(logoName, [file]);
        setIsModalOpen(true);
      };
      reader.readAsDataURL(file);
      event.target.value = "";
    }
  };

  const handleCropComplete = (croppedImageUrl: string) => {
    setCroppedImage(croppedImageUrl);
    setIsModalOpen(false);
    fetch(croppedImageUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File(
          [blob],
          `company-profile.${blob.type.split("/")[1]}`,
          {
            type: blob?.type,
          },
        );
        form.setValue(logoName, [file], { shouldDirty: true });
      });
  };

  return (
    <>
      <Grid2 container spacing={2}>
        <Grid2 size={3} textAlign={"center"}>
          <Avatar
            alt=""
            src={croppedImage || selectedImage || "/Logos/errorImg.svg"}
            sx={{
              width: "90%",
              height: "auto",
              borderRadius: "6px",
              bgcolor: "#EEF2F688",
              p: 1,
            }}
          />
        </Grid2>
        <Grid2 size={9} container spacing={1}>
          <Grid2 gap={1} display={"flex"} alignItems={"center"}>
            <GKButton
              variant="contained"
              component="label"
              role={undefined}
              tabIndex={-1}
            >
              {buttonName}
              <VisuallyHiddenInput
                type="file"
                accept={".jpg, .png, .svg"}
                onChange={handleProfilePicChange}
              />
            </GKButton>
            <IconButton
              onClick={handleProfilePicDelete}
              loading={deleteLoading}
            >
              <DeleteIcon width={18} height={18} color={`var(--warning-700)`} />
            </IconButton>
          </Grid2>
          <Grid2 size={12}>
            <Typography color="#8C95A0" fontSize={12}>
              <span style={{ fontWeight: 600 }}>Upload image</span>: Min. 500 x
              500 px
            </Typography>
            <Typography color="#8C95A0" fontSize={12}>
              <span style={{ fontWeight: 600 }}> Max File Size</span>: 5 MB
            </Typography>
          </Grid2>
        </Grid2>
      </Grid2>
      {isModalOpen && (
        <EditLogoModal
          open={isModalOpen}
          setOpen={setIsModalOpen}
          img={selectedImage || form.getValues(logoName)}
          onCropComplete={handleCropComplete}
        />
      )}
    </>
  );
};

export default GKImageUploader;
